import { Component, Suspense } from 'react';

// project imports
import Loader from './Loader';
import { isStaticResourceLoadError, notifyStaticResourceLoadError } from 'utils/staticResourceError';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

class StaticResourceErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (isStaticResourceLoadError(error)) {
      notifyStaticResourceLoadError(error);
    }
  }

  render() {
    const { error } = this.state;

    if (error) {
      if (isStaticResourceLoadError(error)) return null;
      throw error;
    }

    return this.props.children;
  }
}

const Loadable = (LazyComponent) => (props) => {
  return (
    <StaticResourceErrorBoundary>
      <Suspense fallback={<Loader />}>
        <LazyComponent {...props} />
      </Suspense>
    </StaticResourceErrorBoundary>
  );
};

export default Loadable;
